import { BreakpointObserver, MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, effect, inject, OnInit, signal, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatSidenav, MatSidenavContent } from '@angular/material/sidenav';
import { CoreService } from 'src/app/shared/services/core.service';
import { AppSettings } from 'src/app/config';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { navItems } from './vertical/sidebar/sidebar-data';
import { colorModulo } from 'src/app/shared/constants/menu-colores';
import { NavService } from '../../shared/services/nav.service';
import { AppNavItemComponent } from './vertical/sidebar/nav-item/nav-item.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './vertical/sidebar/sidebar.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TablerIconsModule } from 'angular-tabler-icons';
import { HeaderComponent } from './vertical/header/header.component';
import { AppHorizontalHeaderComponent } from './horizontal/header/header.component';
import { AppHorizontalSidebarComponent } from './horizontal/sidebar/sidebar.component';
import { AppBreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { CustomizerComponent } from './shared/customizer/customizer.component';
import { BrandingComponent } from '../full/vertical/sidebar/branding.component';
import { AppSidebarComponent, IPortalSelected } from './vertical/app-sidebar/app-sidebar.component';
import { RolesMenuService } from 'src/app/apps/nodo/modules/administracion/services/roles-menus.service';
import { style } from '@angular/animations';
import { SStorageService } from 'src/app/shared/services/sessionStorage.service';
import { ChatCandidatoDrawerComponent } from 'src/app/shared/components/chat-candidato-drawer/chat-candidato-drawer.component';
import { ChatGlobalFabComponent } from 'src/app/apps/nodo/modules/comunicaciones/components/chat-global-fab/chat-global-fab';
import { ChatwootNotificationService } from 'src/app/shared/services/chatwoot-notification.service';
import { GuiaUsuarioDrawerComponent } from 'src/app/shared/components/guia-usuario-drawer/guia-usuario-drawer.component';

const MOBILE_VIEW = 'screen and (max-width: 768px)';
const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
const MONITOR_VIEW = 'screen and (min-width: 1024px)';
const BELOWMONITOR = 'screen and (max-width: 1023px)';

// for mobile app sidebar
interface apps {
    id: number;
    icon: string;
    color: string;
    title: string;
    subtitle: string;
    link: string;
}

interface quicklinks {
    id: number;
    title: string;
    link: string;
}

@Component({
    selector: 'app-full',
    imports: [
        RouterModule,
        AppNavItemComponent,
        MaterialModule,
        CommonModule,
        SidebarComponent,
        NgScrollbarModule,
        TablerIconsModule,
        HeaderComponent,
        AppHorizontalHeaderComponent,
        AppHorizontalSidebarComponent,
        AppBreadcrumbComponent,
        AppSidebarComponent,
        ChatCandidatoDrawerComponent,
        ChatGlobalFabComponent,
        GuiaUsuarioDrawerComponent
    ],
    templateUrl: './full.component.html',
    styleUrls: [],
    encapsulation: ViewEncapsulation.None
})
export class FullComponent implements OnInit {
    navItems = navItems;

    @ViewChild('leftsidenav')
    public sidenav: MatSidenav;
    resView = false;
    selectedIcon = 1;

    @ViewChild('content', { static: true }) content!: MatSidenavContent;
    //get options from service
    options = this.settings.getOptions();
    private layoutChangesSubscription = Subscription.EMPTY;
    private isMobileScreen = false;
    private isContentWidthFixed = true;
    private isCollapsedWidthFixed = false;
    private htmlElement!: HTMLHtmlElement;

    selected = 'Mi Portal'; // Cambia según la opción seleccionada
    theme = signal<'light' | 'dark'>('light');
    portalId = signal<string>('');
    logoMi: string = 'assets/images/logos/icono-dark.png'; // Logo de Misión Empresarial

    sstorageService = inject(SStorageService); // Usar SStorageService para acceder a los datos de sesión

    private readonly chatwootNotificationService = inject(ChatwootNotificationService);
    readonly chatTarget = this.chatwootNotificationService.activeChatTarget;

    setSelected(option: string) {
        this.selected = option;
    }

    get logo(): string {
        return this.theme() === 'dark' ? 'assets/images/logos/nexus-d.png' : 'assets/images/logos/nexus-l.png';
    }

    get isOver(): boolean {
        return this.isMobileScreen;
    }

    get isTablet(): boolean {
        return this.resView;
    }

    onIconSelected(icon: number) {
        this.selectedIcon = icon;
    }

    constructor(
        private settings: CoreService,
        private mediaMatcher: MediaMatcher,
        private router: Router,
        private breakpointObserver: BreakpointObserver,
        private navService: NavService,
        private rolesMenuService: RolesMenuService,
        private cdr: ChangeDetectorRef
    ) {
        this.htmlElement = document.querySelector('html')!;
        this.layoutChangesSubscription = this.breakpointObserver
            .observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW, BELOWMONITOR])
            .subscribe((state) => {
                // SidenavOpened must be reset true when layout changes
                this.options.sidenavOpened = true;
                this.options.logo = '/assets/images/logos/nexus-d.png';
                this.isMobileScreen = state.breakpoints[BELOWMONITOR];
                if (this.options.sidenavCollapsed == false) {
                    this.options.sidenavCollapsed = state.breakpoints[TABLET_VIEW];
                }
                this.isContentWidthFixed = state.breakpoints[MONITOR_VIEW];
                this.resView = state.breakpoints[BELOWMONITOR];
            });

        // Initialize project theme with options
        this.receiveOptions(this.options);

        // This is for scroll to top
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((e) => {
            this.content.scrollTo({ top: 0 });
        });
    }

    ngOnInit(): void {}

    onChatVisibleChange(visible: boolean): void {
        if (!visible) this.chatwootNotificationService.closeChat();
    }

    ngOnDestroy() {
        this.layoutChangesSubscription.unsubscribe();
    }

    openClosedMenu() {
        this.options.sidenavCollapsed = false;
        // Selecciona el logo según el modo actual
        this.options.logo = this.options.theme === 'dark' ? '/assets/images/logos/nexus-l.png' : '/assets/images/logos/nexus-d.png';
        this.resetCollapsedState();
    }

    toggleCollapsed() {
        this.isContentWidthFixed = false;
        this.options.sidenavCollapsed = !this.options.sidenavCollapsed;
        if (this.options.sidenavCollapsed) {
            this.options.logo = '';
        } else {
            this.options.logo = this.options.theme === 'dark' ? '/assets/images/logos/nexus-l.png' : '/assets/images/logos/nexus-d.png';
        }
        this.resetCollapsedState();
    }

    resetCollapsedState(timer = 400) {
        setTimeout(() => this.settings.setOptions(this.options), timer);
    }

    onSidenavClosedStart() {
        this.isContentWidthFixed = false;
    }

    onSidenavOpenedChange(isOpened: boolean) {
        this.isCollapsedWidthFixed = !this.isOver;
        this.options.sidenavOpened = isOpened;
        this.settings.setOptions(this.options);
    }

    receiveOptions(options: AppSettings): void {
        this.toggleDarkTheme(options);
        this.toggleColorsTheme(options);
    }

    toggleDarkTheme(options: AppSettings) {
        this.theme.update((t) => (t === 'light' ? 'dark' : 'light'));
        if (options.theme === 'dark') {
            this.htmlElement.classList.add('dark-theme');
            this.htmlElement.classList.remove('light-theme');
        } else {
            this.htmlElement.classList.remove('dark-theme');
            this.htmlElement.classList.add('light-theme');
        }
    }

    toggleColorsTheme(options: AppSettings) {
        // Remove any existing theme class dynamically
        this.htmlElement.classList.forEach((className) => {
            if (className.endsWith('_theme')) {
                this.htmlElement.classList.remove(className);
            }
        });

        // Add the selected theme class
        this.htmlElement.classList.add(options.activeTheme);

        // Cambia el modo dark/light para PrimeNG
        if (options.theme === 'dark') {
            this.htmlElement.classList.add('app-dark');
        } else {
            this.htmlElement.classList.remove('app-dark');
        }
    }

    getMenusByRoleId(portal: IPortalSelected) {
        this.navItems = [];
        return this.rolesMenuService.getMenusbyId(portal.id).subscribe({
            next: (menus) => {
                if (menus != null) {
                    // Aquí puedes manejar los menús recibidos, por ejemplo:
                    this.navItems = menus.data.map((menu: any) => {
                        // Los hijos heredan el color del módulo de primer nivel
                        const color = colorModulo(menu.color, menu.id);
                        return {
                            id: menu.id,
                            displayName: menu.tituloMenu,
                            iconName: menu.icono,
                            route: menu.urlRuta,
                            color,
                            children: menu.items
                                ? menu.items.map((subMenu: any) => ({
                                      id: subMenu.id,
                                      displayName: subMenu.tituloMenu,
                                      iconName: subMenu.icono,
                                      route: subMenu.urlRuta,
                                      color,
                                      children: subMenu.items
                                          ? subMenu.items.map((subSubMenu: any) => ({
                                                id: subSubMenu.id,
                                                displayName: subSubMenu.tituloMenu,
                                                iconName: subSubMenu.icono,
                                                route: subSubMenu.urlRuta,
                                                color
                                            }))
                                          : []
                                  }))
                                : []
                        };
                    });

                    if (!portal.isRefresh && (this.sstorageService.getItem('url') === null || this.sstorageService.getItem('url') === undefined)) {
                        this.sstorageService.setItem('mod', this.navItems[0].id);
                        this.cdr.markForCheck(); // Almacenar el ID del portal seleccionado en sesión solo si no es refresh
                        this.router.navigate([this.navItems[0].route]); // Navegar al primer menú por defecto
                    }
                    // Solo navegar al primer menú si NO es un refresco de página
                }
            },
            error: (err) => {
                // Manejo de errores si la petición falla
                console.error('Error al obtener los menús por rol:', err);
            }
        });
    }
}
